import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import BrandLogo from "@/components/BrandLogo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    setError(""); setResult(null); setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/forgot-password`, { email });
      setResult(res.data);
    } catch (err) {
      setError(err.response?.data?.detail || "Request failed. Please try again.");
    } finally { setLoading(false); }
  }

  return (
    <div className="auth-shell">
      <div className="auth-panel-left">
        <div className="auth-brand">
          <BrandLogo variant="auth" />
          <div className="auth-brand-desc">Reset your password securely to regain access to your account.</div>
        </div>
      </div>

      <div className="auth-panel-right">
        <div className="auth-form-title">Forgot password?</div>
        <div className="auth-form-sub">Enter your email and we'll send you a reset link</div>

        {error && <div className="auth-error" data-testid="forgot-error">{error}</div>}

        {result ? (
          <div data-testid="forgot-result">
            <div className="auth-success" data-testid="forgot-success">
              Reset link sent! Check your inbox at <strong>{email}</strong> and follow the instructions. The link is valid for 1 hour.
            </div>
            <div style={{ fontSize: 11, color: "var(--text2)", marginBottom: 16 }}>
              If you don't see the email, check your spam folder.
            </div>
            <Link to="/login">
              <button className="auth-submit" style={{ marginTop: 0 }} data-testid="back-to-login-btn">
                Back to Sign In
              </button>
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="auth-field">
              <label className="auth-label">Email address</label>
              <input type="email" className="auth-input" placeholder="you@percasa.com" value={email} onChange={e => setEmail(e.target.value)} required data-testid="forgot-email-input" />
            </div>
            <button type="submit" className="auth-submit" disabled={loading} data-testid="forgot-submit-btn">
              {loading ? "Sending..." : "Send Reset Link"}
            </button>
          </form>
        )}

        <div className="auth-link">
          <Link to="/login" data-testid="back-to-login-link">Back to Sign In</Link>
        </div>
      </div>
    </div>
  );
}
